import { httpV1 as http } from '@/services/api';

export async function getPromoterInvoices(params) {
  return http.get('/payments/promoter-invoices', { params });
}

export async function uploadPromoterInvoice(formData) {
  return http.post('/payments/promoter-invoices/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function getPromoterInvoiceById(id) {
  return http.get(`/payments/promoter-invoices/${id}`);
}

export async function updatePromoterInvoiceStatus(id, payload) {
  return http.put(`/payments/promoter-invoices/${id}/status`, payload);
}

export async function updatePromoterInvoiceRetention(id, payload) {
  return http.put(`/payments/promoter-invoices/${id}/retention`, payload);
}

export async function getPixReceipt(externalKey) {
  return http.get(`/payments/pix/receipt/${externalKey}`);
}

export async function getInvoiceFollowUps(params) {
  return http.get('/payments/promoter-invoices/followups', { params });
}

export async function createInvoiceFollowUp(payload) {
  return http.post('/payments/promoter-invoices/followups', payload);
}

export async function updateInvoiceFollowUp(id, payload) {
  return http.put(`/payments/promoter-invoices/followups/${id}`, payload);
}

export async function deleteInvoiceFollowUp(id) {
  return http.delete(`/payments/promoter-invoices/followups/${id}`);
}
